import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import { cn } from "../../utils/index.js";
import { CdnIcon } from "../CdnIcon/CdnIcon.js";
import { Image } from "../Image/Image.js";
import { badgeVariants } from "./Badge.variants.js";
function Badge({ children, className, onClick, iconLeft, image, imageAlt, ...props }) {
    const { badgeSlot, textSlot, iconSlot, imageSlot, imageImg } = badgeVariants(props);
    const iconSize = 'sm' === props.size ? '16' : '20';
    return /*#__PURE__*/ jsxs("div", {
        className: cn(badgeSlot(), className),
        onClick: onClick,
        ...props,
        children: [
            image && /*#__PURE__*/ jsx("span", {
                className: imageSlot(),
                children: /*#__PURE__*/ jsx(Image, {
                    src: image,
                    alt: imageAlt || '',
                    className: imageImg()
                })
            }),
            iconLeft && !image && /*#__PURE__*/ jsx(CdnIcon, {
                className: iconSlot(),
                iconName: iconLeft,
                size: iconSize
            }),
            /*#__PURE__*/ jsx("span", {
                className: textSlot(),
                children: children
            })
        ]
    });
}
export { Badge };
